module.exports = __webpack_public_path__ + "static/media/maroon-bells-autumn.859d30e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/maroon-bells-autumn.jpg
// module id = 116
// module chunks = 0